// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__gj1rt","header":"Messages_header__FtySI"};